export const SET_ZAHLUNGSEINGANG_STATI = "setZahlungseingangStati";